export default "https://assets.egbcdn.net/assets/packs/_/videos/lootbox/video-default-f20c5ec75bc00df29bbc3fe8f7fd1c60.webm";